import React, { useMemo } from 'react';
import StellarLogo from './StellarLogo';

export const WelcomeScreen: React.FC = () => {
    // Générer des étoiles de manière déterministe pour le rendu initial mais avec l'apparence de l'aléatoire
    const stars = useMemo(() => {
        return Array.from({ length: 50 }).map((_, i) => ({
            id: i,
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
            size: `${Math.random() * 2 + 1}px`,
            delay: `${Math.random() * 5}s`,
            duration: `${Math.random() * 3 + 2}s`,
            type: Math.random() > 0.8 ? (Math.random() > 0.5 ? 'star-blue' : 'star-cyan') : ''
        }));
    }, []);

    return (
        <div className="fixed inset-0 z-[9999] bg-[#0d1117] flex flex-col items-center justify-center overflow-hidden">
            {/* Real Nebula Background */}
            <img
                src="/images/splash_bg.webp"
                alt="Background"
                className="absolute inset-0 w-full h-full object-cover"
            />

            {/* Stars Layer overlayed on nebula */}
            <div className="absolute inset-0 pointer-events-none">
                {stars.map((star) => (
                    <div
                        key={star.id}
                        className={`star ${star.type}`}
                        style={{
                            top: star.top,
                            left: star.left,
                            width: star.size,
                            height: star.size,
                            '--delay': star.delay,
                            '--duration': star.duration,
                        } as React.CSSProperties}
                    />
                ))}
            </div>

            {/* Bottom status */}
            <div className="absolute bottom-20 text-white/40 text-[10px] font-bold tracking-[0.4em] uppercase animate-pulse">
                Initialisation de votre ciel...
            </div>
        </div>
    );
};

export default WelcomeScreen;

